"use client"

import type * as React from "react"
import { Building2, Target, CheckCircle, Settings } from "lucide-react"
import Image from "next/image"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import { TeamSwitcher } from "@/components/team-switcher"
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarRail } from "@/components/ui/sidebar"

const organizationData = {
  user: {
    name: "Organization User",
    email: "org@example.com",
  },
  teams: [
    {
      name: "Sponsorship Portal",
      logo: ({ className }: { className?: string } = {}) => (
        <Image
          src="/zipsprout-icon.png"
          alt="Zipsprout"
          width={16}
          height={16}
          className={className || "size-4"}
          style={{
            width: "auto",
            height: "100%",
            objectFit: "contain",
            mixBlendMode: "screen",
          }}
        />
      ),
      plan: "Organization",
    },
  ],
  navMain: [
    {
      title: "Dashboard",
      url: "/organization/dashboard",
      icon: Building2,
      isActive: true,
    },
    {
      title: "Sponsorship Opportunities",
      url: "/organization/opportunities",
      icon: Target,
    },
    {
      title: "Sponsorships Placed",
      url: "/organization/placed",
      icon: CheckCircle,
    },
    {
      title: "Settings",
      url: "/organization/settings",
      icon: Settings,
    },
  ],
}

export function OrganizationSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={organizationData.teams} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={organizationData.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={organizationData.user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
